import React from "react";
import { Radio as AntRadio } from "antd";
import PropTypes from "kf-proptypes/widgets";

import "antd/es/radio/style/css";
import "./radio.override.css";
import styles from "./radio.css";

export const RADIO_SIZES = {
  BASE: "base",
  MEDIUM: "medium"
};

export function Radio({
  checked,
  className = "",
  label,
  id,
  name,
  disabled,
  readOnly,
  onChange,
  size = RADIO_SIZES.BASE
}) {
  const onValueChange = (e) => {
    if (readOnly) {
      return;
    }
    onChange(e);
  };

  return (
    <div
      className={`${styles.radioContainer} ${styles[size]}`}
      data-component="radio"
    >
      <AntRadio
        id={id}
        name={name}
        checked={checked}
        aria-checked={checked}
        className={`${className} ${readOnly ? "readOnly" : ""} ${
          disabled ? "disabled" : ""
        } `}
        disabled={disabled}
        onChange={onValueChange}
        onKeyDown={(e) => (e.key === "Enter" ? onValueChange(e) : "")}
      >
        <span
          className={`${styles.radioLabel} ${disabled ? styles.disabled : ""}`}
        >
          {label}
        </span>
      </AntRadio>
    </div>
  );
}

Radio.propTypes = {
  /** To override the styles of the element. */
  className: PropTypes.string,
  /** The title of the radio button. */
  label: PropTypes.string.isRequired,
  /**  Unique element to identify the id */
  id: PropTypes.string,
  /** Name for the input element */
  name: PropTypes.string.isRequired,
  /** Wheather the radio button is in disabled state or not. */
  disabled: PropTypes.bool,
  /** Is the radio button checked? Or not?  */
  checked: PropTypes.bool.isRequired,
  /** A callback function that gets invoked when the radio button goes from checked to unchecked and vice versa.*/
  onChange: PropTypes.func.isRequired,
  /** Is the radio button in read only mode? */
  readOnly: PropTypes.bool,
  /** Size of the radio button (MEDIUM | BASE) */
  size: PropTypes.oneOf(Object.values(RADIO_SIZES))
};

Radio.defaultProps = {
  className: "",
  label: "",
  size: RADIO_SIZES.BASE
};
